import React from 'react'

import { AsyncSelect } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'

import { IdGen } from 'utils'

import * as ProductoService from 'services/producto.service'

const ProductoFormGroup = ({ dispatch, autoFocus }) => {
  const __adminContext = React.useContext(AdminContext)

  const [__keySelect, setKeySelect] = React.useState(IdGen.newId())

  const loadProductosSelect = React.useCallback((inputValue, resolve) => {
    ProductoService.obtenerAsComprasSelect2({
      busqueda: inputValue
    }).then(({ data }) => resolve(data))
  }, [])

  const onChange = React.useCallback(
    productoSeleccionado => {
      ProductoService.getProducto_Compras(productoSeleccionado.value).then(({ data }) => {
        dispatch({
          type: 'agregar',
          payload: {
            _idProducto: data._idProducto,
            _idProductoPresentacion: data._idProductoPresentacion,
            unidadMedida: data.nombreUnidadDeMedida,
            codigoProducto: data.codigoProducto,
            nombreProducto: data.nombreProducto
          }
        })
        setKeySelect(IdGen.newId())
      })
    },
    [dispatch]
  )

  return (
    <AsyncSelect
      key={__keySelect}
      selectId='productoSelect'
      loadOptions={loadProductosSelect}
      onChange={onChange}
      defaultMenuIsOpen={autoFocus && !__adminContext.valoresConfiguracionCompania.flagCodigoBarra}
      autoFocus={autoFocus && !__adminContext.valoresConfiguracionCompania.flagCodigoBarra}
    />
  )
}

export default React.memo(ProductoFormGroup)
